import { hasCapability } from "@/utils/capability";

import { usePlatformCapabilities } from "../capability/usePlatformCapabilities";

/**
 * Whether the current user may VIEW the current platform's settings page
 * (`PLATFORM_SETTINGS:READ` on the platform capability set — the same key
 * guarding `GET /platforms/:id`, so the page only opens when the detail
 * request will succeed). UpdatePlatformPage renders read-only without
 * `PLATFORM_SETTINGS:WRITE`. See docs/capabilities.md.
 */
export const useCanViewPlatformSettings = () => {
  const platformCapabilities = usePlatformCapabilities();

  return hasCapability(platformCapabilities, "PLATFORM_SETTINGS:READ");
};
